import Div from "@jumbo/shared/Div/Div";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import "./PreviewForms.css";
import IconButton from "@mui/material/IconButton";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {get, patch, post, put} from "../../common/network";
import FormReplaceModal from "../../components/common/modal-preview/FormReplaceModal";
import LastFormSaveModal from "../../components/common/modal-preview/LastFormSaveModal";
import ReadyForFilingModal from "../../components/common/modal-preview/ReadyForFilingModal";
import PdfFormPreview from "../../components/common/preview-form/PdfFormPreview";
import PreviewModifyFormsSelected from "../../components/common/preview-forms-selected/PreviewModifyFormsSelected";
import Form_ADS from "../../components/xfa-forms/Form_ADS";
import Form_SB_08 from "../../components/xfa-forms/Form_SB_08";
import Form_SB_16 from "../../components/xfa-forms/Form_SB_16";
import Form_SB_28 from "../../components/xfa-forms/Form_SB_28";
import Form_SB_30 from "../../components/xfa-forms/Form_SB_30";


const ModifyForm = ({isEditable}) => {
    const queryParams = new URLSearchParams(window.location.search);
    const sharedIds = queryParams.getAll("id");

    const [selectedForm, setSelectedForm] = useState("");
    const [selectedMatter, setSelectedMatter] = useState(0);
    const [formList, setFormList] = useState([]);
    const [formData, setFormData] = useState([]);
    const [currentFormData, setCurrentFormData] = useState(null);
    const [matterContacts, setMatterContacts] = useState([]);
    const [xfaCombinedData, setXfaCombinedData] = useState([]);
    const [xfaGeneratedForm, setXfaGeneratedForm] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isPreviousFormData, setPreviousFormData] = useState(null);
    const [readyForFilingOpen, setReadyForFilingOpen] = useState(false);
    const [upperSectionProps, setUpperSectionProps] = useState({});
    const [disabledFiling, setDisabledFiling] = useState(false);
    const [filingLoading, setFilingLoading] = useState(false);
    const [checkedForms, setCheckedForms] = useState({});
    const [replaceModalOpen, setReplaceModalOpen] = useState(false);
    const [lastFormSaveModalOpen, setLastFormSaveModalOpen] = useState(false);
    const [confirmRedirect, setConfirmRedirect] = useState(false);
    const [disableSaveNext, setDisableSaveNext] = useState(false);
    const combinedData = formList?.flatMap((generated) => ({
        generatedformid: generated.id
    }));
    let xfaCombinedArray = formList?.filter(data => data?.generated_form?.isXfa)?.map(form => ({
            form_id: form.id,
            generatedformid: form.id,
            matter_id: form.matter_id
        }
    ));
    let nonXfaCombinedData = combinedData?.filter(data => {
        if (!formList.find(form => form.id === data.generatedformid)?.generated_form?.isXfa) {
            return true;
        }
    });

    useEffect(() => {
        setXfaCombinedData(xfaCombinedArray);
    }, [formList]);

    useEffect(() => {
        if (confirmRedirect) {
            navigate("/docgen/drafts");
        }
    }, [confirmRedirect]);

    useEffect(() => {
        if (!isPreviousFormData) {
            setDisableSaveNext(true);
        } else {
            setDisableSaveNext(false);
        }
    }, [isPreviousFormData]);

    //#region for api call to fetch favorite form list
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await post(`docgen/generate-forms-by-ids`, {
                    formIds: sharedIds
                });
                setFormList(response.data || []);
                setSelectedForm(response.data?.length > 0 ? response.data[0]?.id : "");
            } catch (error) {
            }
        };
        fetchData();
    }, []);

    //#endregion

    //#region for useEffect to fetch details of a Form by form id
    const fetchFormData = async (selectedForm) => {
        try {
            setIsLoading(true);
            let response;
            if (formList.find(form => form.id === selectedForm)?.generated_form?.isXfa) {
                response = await get(`docgen/forms/generate/${selectedForm}/data`);
                setXfaGeneratedForm(response);
            } else {
                if (selectedForm) {
                    response = await post(`docgen/generated-forms`, {
                        generated_id: selectedForm
                    });
                    setFormData(response);
                    return response;
                }
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const fetchMatterData = async () => {
            try {
                const response =
                    matterId && await get(
                        `docgen/matters/${matterId}`
                    );
                let matterData = response?.data?.matter_parties || []
                (xfaGeneratedForm?.signatories || []).forEach(sig => {
                matterData.forEach(m => {
                    if (
                    m.party_type === "Attorney" &&
                    m.party?.name === sig.name
                    ) {
                    m.party.reference_no = sig.referenceNo;
                    }
                });
                });
                setMatterContacts(matterData);
            } catch (error) {
            }
        };
        if(selectedForm?.isXfa){
            fetchMatterData();
        }
    }, [selectedForm, xfaGeneratedForm]);
    //#endregion

    useEffect(() => {
        setPreviousFormData(null);
        const matterId = formList.find(form => form.id === selectedForm)?.matter_id || "";
        setSelectedMatter(matterId);

        fetchFormData(selectedForm);
    }, [selectedForm])

    const fetchExistingFormData = async (selectedForm, selectedMatter, status) => {
        if (selectedForm && selectedMatter) {
            return await get(`docgen/check-existing-generated-forms`, {
                params: {
                    formId: selectedForm,
                    matterId: selectedMatter,
                    status: status
                }
            });
        }
    };

    const navigate = useNavigate();

    const onSaveAndNext = async () => {
        if (isEditable !== false) {
            if (formList.find(form => form.id === selectedForm)?.generated_form?.isXfa) {
                const selectedXfa = xfaCombinedData?.find(xfaData => xfaData.generatedformid === selectedForm);

                if (selectedXfa) {
                    const requestBody = {
                        formId: selectedXfa?.generatedformid,
                        status: "Draft",
                        data: selectedXfa?.matter_records ? {
                            signatories: selectedXfa.matter_records?.map(p => ({name: p.name, referenceNo: p.referenceNo})) || []
                        } : {...selectedXfa.data}
                    };

                    try {
                        setIsLoading(true);
                        const response = await patch(`/docgen/forms/generate`, requestBody);
                        if (!response.statusCode) {
                            toast.success("Form generated successfully");
                        }
                    } catch (error) {
                    } finally {
                        setIsLoading(false);
                    }
                } else {
                    toast.error("No form or docket selected");
                }
            } else {
                setIsLoading(true);
                try {
                    const response = await put(`/docgen/generated-forms`, {
                        generatedformid: selectedForm,
                        data: currentFormData,
                        status: "Draft",
                        previousData: isPreviousFormData
                    });

                    if (response?.success) {
                        toast.success(response?.message);
                    }
                } finally {
                    setIsLoading(false);
                }
            }
        }

        const currentFormIndex = formList.findIndex(
            (item) => item.id === selectedForm
        );

        if (currentFormIndex !== -1) {
            let nextFormIndex = (currentFormIndex + 1);
            if (nextFormIndex === formList.length && isEditable !== false) {
                setLastFormSaveModalOpen(true);
                await fetchFormData(selectedForm);
            }

            if (nextFormIndex !== formList.length) {
                setUpperSectionProps((prevState) => ({...prevState, selectedItem: formList[nextFormIndex]?.id}));
                setSelectedForm(formList[nextFormIndex]?.id);
            }
        } else if (formList.length > 0) {
            setSelectedForm(formList[0].id); // Go to the first form
            setUpperSectionProps((prevState) => ({...prevState, selectedItem: formList[0]?.id}));
        }

    };

    const backHandler = () => {
        const currentFormIndex = formList.findIndex(
            (item) => item.id === selectedForm
        );

        if (currentFormIndex !== -1) {
            const previousFormIndex = currentFormIndex - 1;
            const nextFormIndex =
                previousFormIndex < 0 ? formList.length - 1 : previousFormIndex;

            setSelectedForm(formList[nextFormIndex]?.id);
            setUpperSectionProps((prevState) => ({...prevState, selectedItem: formList[nextFormIndex]?.id}));
        } else if (formList.length > 0) {
            setUpperSectionProps((prevState) => ({...prevState, selectedItem: formList[formList.length - 1]?.id}));
            setSelectedForm(formList[formList.length - 1]?.id);
        }
    };

    const completeAll = async (filingParameters) => {
        let errorExists = false;

        const filterForms = (item) => {
            const response = filingParameters.find((parameter) => parameter.generatedformid === String(item.generatedformid));
            if (response) {
                return true;
            }
        };

        const completeDraftXfa = async () => {
            await Promise.all(
                xfaCombinedData?.filter(item => filterForms(item))?.map(async xfaData => {
                    const requestBody = {
                        formId: xfaData.generatedformid,
                        status: "Completed",
                        data: xfaData?.matter_records ? {
                            signatories: xfaData.matter_records?.map(p => ({name: p.name, referenceNo: p.referenceNo})) || []
                        } : {...xfaData.data}
                    };

                    try {
                        const response = await patch(`/docgen/forms/generate`, requestBody);
                        if (response?.statusCode === 500 || response?.statusCode === 404 || response?.statusCode === 400 || response?.statusCode === 504) {
                            errorExists = true;
                        }
                    } catch (error) {
                        errorExists = true;
                    }
                })
            );
        };

        const completeDraftNonXfa = async () => {
            if (nonXfaCombinedData.length > 0) {
                const selectedFormList = filingParameters?.map(item => item.generatedformid);
                const nonXfaFormIndex = upperSectionProps?.selectedItems?.findIndex(form => !form?.generated_form?.isXfa && selectedFormList.includes(String(form.id)));

                let selectedFormId;
                if (upperSectionProps?.selectedItems?.find(item => item.id === selectedForm)?.generated_form?.isXfa) {
                    selectedFormId = upperSectionProps?.selectedItems?.[nonXfaFormIndex]?.id;
                } else {
                    const viewer = document.getElementById("preview-form-container").ej2_instances[0];

                    if (viewer?.isRendered) {
                        const getFormFieldsData = () => {
                            return new Promise((resolve, reject) => {
                                viewer.documentLoad = async () => {
                                    try {
                                        let formFieldsData = (await viewer.exportFormFieldsAsObject())?.replace(/_x([0-9A-Fa-f]{4})_/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)));
                                        formFieldsData = formFieldsData.replace(/#([0-9A-Fa-f]{2})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)));
                                        resolve(formFieldsData);
                                    } catch (error) {
                                        reject(error);
                                    }
                                };
                            });
                        };

                        const fetchFormFieldsDirectly = async () => {
                            return new Promise(async (resolve, reject) => {
                                try {
                                    let formFieldsData = (await viewer.exportFormFieldsAsObject())?.replace(/_x([0-9A-Fa-f]{4})_/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)));
                                    formFieldsData = formFieldsData.replace(/#([0-9A-Fa-f]{2})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16)));
                                    resolve(formFieldsData);
                                } catch (error) {
                                    reject(error);
                                }
                            });
                        };

                        selectedFormId = selectedForm;
                        const formFieldsData = await Promise.race([getFormFieldsData(), fetchFormFieldsDirectly()]);

                        // Check if the pair exists in the combinedData array
                        const existingPairIndex = nonXfaCombinedData.findIndex(
                            (item) => item.generatedformid === selectedFormId
                        );

                        if (existingPairIndex !== -1) {
                            // Update the existing pair with formFieldsData, and status
                            nonXfaCombinedData[existingPairIndex].changedData = formFieldsData;
                            nonXfaCombinedData[existingPairIndex].status = "Completed";
                            nonXfaCombinedData[existingPairIndex].previousData = isPreviousFormData;
                        } else {
                            // Add the new pair to the combinedData array
                            nonXfaCombinedData.push({
                                generatedformid: selectedFormId,
                                changedData: formFieldsData,
                                status: "Completed",
                                previousData: isPreviousFormData
                            });
                        }
                    }
                }


                // Update the status of all objects in the combinedData array to "Completed"
                const updatedCombinedData = nonXfaCombinedData.filter(item => filterForms(item))?.map((pair) => ({
                    ...pair,
                    status: "Completed"
                }));

                const sendResponse = async () => {
                    const response = await put(`/docgen/all-generated-forms`, {
                        data: updatedCombinedData
                    });
                    if (response?.success === true) {
                        if (response?.error?.length > 0) {
                            errorExists = true;
                            response.error.forEach((e) => {
                                toast.error(e);
                            });
                        }
                    } else {
                        errorExists = true;
                        throw new Error(response?.error);
                    }
                };
                await sendResponse();
            }
        };

        Promise.all([completeDraftXfa(), completeDraftNonXfa()])
               .then(() => {
                   setFilingLoading(false);
                   if (!errorExists) {
                       toast.success("All selected form(s) marked as complete");
                       const filingParametersIds = filingParameters.map(param => param.generatedformid);
                       setUpperSectionProps((prevState) => {
                           const newState = {...prevState};
                           const newFormList = newState.selectedItems.filter(item => !filingParametersIds.includes(String(item.id)));
                           return (
                               {...prevState, selectedItems: newFormList}
                           );
                       });

                       const updatedFormList = formList.filter((form) => !filingParametersIds.includes(String(form.id)));
                       setFormList(updatedFormList);
                       setCheckedForms({});
                   }
               })
               .catch(() => {
                   setFilingLoading(false);
               });
    };

    const handleFiling = async () => {
        try {
            setFilingLoading(true);

            let filingParameters = [];
            for (const generatedFormId of Object.keys(checkedForms).filter(item => checkedForms[item])) {

                const formCode = formList.find((form) => String(form.id) === generatedFormId)?.generated_form?.form_code;
                const formId = formList.find((form) => String(form.id) === generatedFormId)?.form_id;
                const matterId = formList.find((form) => String(form.id) === generatedFormId)?.matter_id;
                const matterName = formList.find((form) => String(form.id) === generatedFormId)?.generated_form_matter?.host_file_number;

                const response = await fetchExistingFormData(formId, matterId, "Completed");

                if (response.data) {
                    setReplaceModalOpen(true);
                    const userConfirmed = await new Promise((resolve) => {
                        const handleConfirm = () => {
                            setReplaceModalOpen(false);
                            resolve(true);
                        };

                        const handleCancel = () => {
                            setReplaceModalOpen(false);
                            resolve(false);
                        };

                        setReplaceModalOpen({onConfirm: handleConfirm, onCancel: handleCancel, matterName: matterName, formCode: formCode});
                    });

                    if (userConfirmed) {
                        filingParameters.push({generatedformid: generatedFormId});
                    } else {
                        setUpperSectionProps((prevState) => {
                            const newState = {...prevState};
                            const newFormList = newState.selectedItems.filter(item => String(item.id) !== generatedFormId);
                            return (
                                {...prevState, selectedItems: newFormList}
                            );
                        });
                        const updatedFormList = formList.filter((form) => String(form.id) !== generatedFormId);
                        setFormList(updatedFormList);
                    }
                } else {
                    filingParameters.push({generatedformid: generatedFormId});
                }
            }

            if (filingParameters.length > 0) {
                const checkAndFile = async () => {
                    if (!upperSectionProps?.selectedItems?.find(form => form.id === selectedForm)?.generated_form?.isXfa) {
                        const viewer = document.getElementById("preview-form-container")?.ej2_instances[0];

                        if (viewer && viewer.isRendered) {
                            await completeAll(filingParameters);
                        } else {
                            setTimeout(checkAndFile, 1000);
                        }
                    } else {
                        await completeAll(filingParameters);
                    }
                };
                await checkAndFile();
            } else {
                setFilingLoading(false);
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        const uncheckedForms = Object.keys(checkedForms).every((key) => checkedForms[key] === false);
        if (!uncheckedForms) {
            setDisabledFiling(false);
        } else {
            setDisabledFiling(true);
        }
    }, [checkedForms]);

    let formComponent;
    const formCode = formList?.find(form => form.id === selectedForm)?.generated_form?.form_code;
    switch (formCode) {
        case "SB-28":
            formComponent =
                <Form_SB_28 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}
                            xfaGeneratedForm={xfaGeneratedForm} modify={true}/>;
            break;
        case "AIA-14":
            formComponent =
                <Form_ADS matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                          xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}
                          xfaGeneratedForm={xfaGeneratedForm} modify={true}/>;
            break;

        case "SB-08":
            formComponent =
                <Form_SB_08 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}
                            xfaGeneratedForm={xfaGeneratedForm} modify={true}/>;
            break;

        case "SB-16":
            formComponent =
                <Form_SB_16 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}
                            xfaGeneratedForm={xfaGeneratedForm} modify={true}/>;
            break;

        case "SB-30":
            formComponent =
                <Form_SB_30 matterContacts={matterContacts} selectedMatter={selectedMatter} selectedForm={selectedForm}
                            xfaCombinedData={xfaCombinedData} setXfaCombinedData={setXfaCombinedData}
                            xfaGeneratedForm={xfaGeneratedForm} modify={true}/>;
            break;

        default:
            formComponent = null;
    }

    //#endregion

    return (
        <div className="page-content-wrapper">
            <Box className="w-100">
                <header className="section-heading">
                    <Box flexGrow={1}/>
                    <Box sx={{display: "flex", flexDirection: "row"}}>
                        {isEditable !== false && (
                            <>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="error"
                                    onClick={() => navigate("/docgen/drafts")}
                                    sx={{
                                        borderWidth: "2px !important"
                                    }}
                                >
                                    Discard
                                </Button>

                                {/*{filingLoading ? <CircularProgress sx={{color: "blue", marginLeft: "5%"}}/> :
                                    <Button
                                        type="button"
                                        className="ms-2"
                                        onClick={handleFiling}
                                        sx={{
                                            backgroundColor: "#6666b6 !important",
                                            color: "#fff !important",
                                            "&:hover": {
                                                backgroundColor: "#5d5d9a !important"
                                            },
                                            "&:disabled": {
                                                backgroundColor: "#EBE4D1 !important"
                                            }
                                        }}
                                        disabled={isLoading || filingLoading || disabledFiling}
                                    >
                                        Ready For Filing
                                    </Button>}*/}
                            </>)}
                    </Box>
                </header>
                <div>
                    <div className="preview-form-layout"
                         style={{
                             pointerEvents: isLoading || filingLoading ? "none" : "auto", // Disable interactions when loading
                             opacity: isLoading || filingLoading ? 0.5 : 1
                         }}
                    >
                        <Div
                            sx={{
                                backgroundColor: "#eee !important"
                            }}
                            className="selected-forms-area"
                        >
                            {selectedForm ? (
                                <PreviewModifyFormsSelected
                                    upperSectionProps={upperSectionProps}
                                    setUpperSectionProps={setUpperSectionProps}
                                    upperSectionItems={{
                                        title: "Docket No. / Form Code",
                                        selectedItems: formList,
                                        selectedItem: selectedForm,
                                        setColor: "green-chip"
                                    }}
                                    setSelectedForm={setSelectedForm}
                                    checkedForms={checkedForms}
                                    setCheckedForms={setCheckedForms}
                                    isEditable={isEditable}
                                    formList={formList}
                                    setFormList={setFormList}
                                />
                            ) : (
                                ""
                            )}
                        </Div>
                        {isLoading ? (
                            <Div
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    minHeight: "60vh",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",

                                    ".btn-loader-icon": {
                                        width: "60px",
                                        height: "60px",
                                        border: "5px solid gray",
                                        borderColor: "transparent gray gray gray",
                                        borderRadius: "50%",
                                        animation: "rotate .5s linear infinite"
                                    }
                                }}
                            >
                                <div className="btn-loader-icon"/>
                            </Div>
                        ) : formList.find(form => form.id === selectedForm)?.generated_form?.isXfa ? (
                            <div className="syncfusion-form-area">
                                <IconButton
                                    sx={{
                                        top: "50%",
                                        transform: "translateY(-50%)"
                                    }}
                                    onClick={backHandler}
                                >
                                    <ArrowBackIosNewOutlinedIcon/>
                                </IconButton>
                                {formComponent}
                                <IconButton
                                    size="small"
                                    sx={{
                                        top: "50%",
                                        transform: "translateY(-50%)"
                                    }}
                                    onClick={onSaveAndNext}
                                >
                                    <ArrowForwardIosOutlinedIcon/>
                                </IconButton>
                            </div>
                        ) : (
                            <div className="syncfusion-form-area">
                                <IconButton
                                    sx={{
                                        top: "50%",
                                        transform: "translateY(-50%)"
                                    }}
                                    disabled={disableSaveNext}
                                    onClick={backHandler}
                                >
                                    <ArrowBackIosNewOutlinedIcon/>
                                </IconButton>
                                <div className="container">
                                    <PdfFormPreview formData={formData} setCurrentFormData={setCurrentFormData} previousFormData= {isPreviousFormData} setPreviousFormData={setPreviousFormData}/>
                                </div>
                                    <IconButton
                                        sx={{
                                            top: "50%",
                                            transform: "translateY(-50%)"
                                        }}
                                        disabled={disableSaveNext}
                                        onClick={onSaveAndNext}
                                    >
                                        <ArrowForwardIosOutlinedIcon/>
                                    </IconButton>
                                </div>
                        )}
                    </div>
                </div>
                <ReadyForFilingModal readyForFilingOpen={readyForFilingOpen} setReadyForFilingOpen={setReadyForFilingOpen} setConfirmFiling={() => {
                }}/>
                <FormReplaceModal replaceModalOpen={replaceModalOpen} onConfirm={replaceModalOpen?.onConfirm} onCancel={replaceModalOpen?.onCancel} matterName={replaceModalOpen?.matterName} formCode={replaceModalOpen?.formCode}/>
                <LastFormSaveModal lastFormSaveModalOpen={lastFormSaveModalOpen} setLastFormSaveModalOpen={setLastFormSaveModalOpen} setConfirmRedirect={setConfirmRedirect}/>
            </Box>
        </div>
    );
};


export default ModifyForm;